import "--sideEffects";
import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import { App } from "./App";

function renderAllReactRoots() {
  [...document.getElementsByClassName("react-rendered")].forEach(e => {
    const root = createRoot(e);
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>,
    );
  });
}

renderAllReactRoots();
